
export const getListOfLoginSessions = {
    REQUEST: 'GET_LIST_OF_LOGIN_SESSIONS_REQUEST',
    SUCCESS: 'GET_LIST_OF_LOGIN_SESSIONS_SUCCESS',
    FAILURE: 'GET_LIST_OF_LOGIN_SESSIONS_FAILURE'
}